import { View, Text } from 'react-native'
import { useRouter } from 'expo-router'
import { Routes } from '@/src/common/enums/routes'
import { Button } from '@/src/common/components/Button'
import { useSardine } from '@/src/services/Sardine'
import { useEffect } from 'react'
import { CardApplicationWrapper } from './cardApplicationWrapper'
import { typography } from '@/src/common/theme'
import { cardApplicationStyles as commonStyle } from './common'

export function ApplicationManualReview() {
  const router = useRouter()
  const { updateOptions } = useSardine()

  useEffect(() => {
    void updateOptions({ flow: 'application-manual-review' })
  }, [updateOptions])

  return (
    <CardApplicationWrapper>
      <View style={commonStyle.headerText}>
        <Text style={typography['heading/heading2']}>You're almost done</Text>
      </View>
      <Text style={commonStyle.instructionText}>
        Additional documentation verification is required. Please tap below to proceed with
        uploading supporting documentation to proceed with your application decision.
      </Text>
      <View style={{ flex: 1 }} />
      <View style={{ marginBottom: 0, gap: 10 }}>
        <Button
          title="Verify Identity"
          onPress={() => router.replace(Routes.DocumentUpload.route)}
        />
        <Button
          title="Return Home"
          buttonStyle={commonStyle.returnHomeButtonStyles}
          titleStyle={commonStyle.returnHomeTitleStyles}
          onPress={() => router.replace(Routes.Main.route)}
        />
      </View>
    </CardApplicationWrapper>
  )
}
